import { Tooltip, TooltipProvider } from '@lastbrand/web-ui/tooltip'
import { useTranslation } from 'next-i18next'
import React from 'react'

import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'

import InfoIcon from './infoIcon.inline.svg'
import {
  traditionalDiscountIconDsClass,
  traditionalDiscountWrapperDsClass,
} from './product-traditional-discount-message-ds.styles'

import type { ProductTraditionalDiscountMessageProps } from './product-traditional-discount-message.types'

// DS twin of legacy `ProductTraditionalDiscountMessage` — identical logic; legacy SCSS swapped for
// Panda tokens so the copy stops scaling up under the DS 16px root. Shared `ToolTipWrapper` reused.
export const ProductTraditionalDiscountMessageDS = ({
  formattedTraditionalPrice,
  traditionalDiscountMessage,
}: ProductTraditionalDiscountMessageProps) => {
  const { deviceType } = useDeviceInfo()
  const isDesktop = deviceType === DEVICE_TYPES.DESKTOP
  const { t } = useTranslation('common')
  const tooltipText = t('traditional_discount_tooltip')
  return (
    <>
      {!formattedTraditionalPrice && traditionalDiscountMessage && (
        <div className={traditionalDiscountWrapperDsClass}>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: getSanitizedHtml(traditionalDiscountMessage),
            }}
          ></div>
          <TooltipProvider>
            <Tooltip textLabel={tooltipText} aria-label={tooltipText} position={isDesktop ? 'top' : 'bottom'}>
              <button type="button" aria-label={tooltipText} className={traditionalDiscountIconDsClass}>
                <InfoIcon />
              </button>
            </Tooltip>
          </TooltipProvider>
        </div>
      )}
    </>
  )
}
